import { overviewPoints } from "@/mocks/home";

function SectionHeading({
  eyebrow,
  title,
  desc,
}: {
  eyebrow: string;
  title: string;
  desc: string;
}) {
  return (
    <div className="mx-auto max-w-3xl text-center">
      <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
    </div>
  );
}

export default function Overview() {
  return (
    <section id="overview" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="师兄系列 · 概览"
          title="师兄系列讲的是一条关系线"
          desc="与其把它当成一个固定的榜单，不如先理解这类作品的共同结构：师门、同门与大师兄，三者之间的关系变化，才是观众真正在追的东西。"
        />

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {overviewPoints.map((p) => (
            <div
              key={p.title}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${p.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 items-center gap-6 overflow-hidden rounded-lg border border-background-200/70 bg-background-100 p-5 md:grid-cols-2 md:p-8">
          <div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              同门电影与大师兄电影的区别在哪
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              同门电影是一个更宽的说法，凡是围绕同门人物关系展开的都可以归入其中；大师兄电影则更聚焦于「大师兄」这个位置本身——他常常既是带头人，也是必须站出来承担结果的那个人。
            </p>
            <ul className="mt-5 space-y-3">
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <span className="mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-xs" />
                </span>
                同门电影：范围更宽，重在人物关系网
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <span className="mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-xs" />
                </span>
                大师兄电影：聚焦核心角色与责任
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground-700">
                <span className="mt-1 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-xs" />
                </span>
                两者在师门设定上互相重叠，可以对照着看
              </li>
            </ul>
          </div>
          <div className="h-56 w-full overflow-hidden rounded-lg md:h-72">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20cinematic%20scene%20of%20an%20old%20training%20hall%20with%20wooden%20pillars%20and%20soft%20light%20through%20paper%20windows%2C%20calm%20disciplined%20atmosphere%2C%20stylized%20art%2C%20no%20people%2C%20rich%20amber%20and%20brown%20tones&width=1000&height=700&seq=master-overview-07&orientation=landscape"
              alt="传统武馆训练厅的暖色氛围示意图"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}